export const ALERT_CREATION_UNKNOWN_SECTION = 0;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2 = 2;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM = 3;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP = 5;
export const ALERT_CREATION_SECTION_MOBILE_BOTTOM = 10;
export const ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM = 11;
export const ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_3 = 25;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_3 = 28;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM_STEP_2 = 29;
export const ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP_STEP_2 = 30;
export const ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2 = 66;
export const ALERT_CREATION_SECTION_ADPAGE_BOX = 100;
export const ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT = 103;
export const ALERT_CREATION_SECTION_MANAGE_MERGED = 198;
